import SectionIntro from "./SectionIntro";
import { latestReleases } from "@/mocks/softwareData";

export default function LatestReleases() {
  return (
    <section id="releases" className="bg-background-50 py-12 md:py-16">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <SectionIntro
          eyebrow="RELEASE FEED"
          title="最新版本速递"
          desc="最近一周上架的新版本与安装包，标题即要点，点开看完整更新内容。"
          action={{ label: "全部版本", href: "#featured", icon: "ri-arrow-right-up-line" }}
        />

        <div className="mt-8 grid grid-cols-1 gap-4 lg:grid-cols-2">
          {latestReleases.map((r) => (
            <article
              key={r.id}
              className="flex flex-col gap-3 rounded-xl border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200 hover:bg-primary-50"
            >
              <div className="flex items-start justify-between gap-3">
                <div className="flex items-center gap-2">
                  <h3 className="font-display text-lg font-bold text-foreground-950">{r.name}</h3>
                  <span className="whitespace-nowrap rounded bg-primary-100 px-2 py-0.5 text-xs font-bold text-primary-600">
                    v{r.version}
                  </span>
                </div>
                <span className="whitespace-nowrap text-xs text-foreground-400">{r.date}</span>
              </div>

              <p className="text-sm leading-relaxed text-foreground-700">{r.summary}</p>

              <div className="mt-auto flex flex-wrap items-center justify-between gap-3 border-t border-background-200 pt-3">
                <div className="flex flex-wrap items-center gap-2">
                  {r.platform.map((p) => (
                    <span
                      key={p}
                      className="flex items-center gap-1 rounded-full bg-background-50 px-2.5 py-1 text-xs font-medium text-foreground-600"
                    >
                      <i className={p === "安卓" ? "ri-android-line" : "ri-apple-line"}></i>
                      {p}
                    </span>
                  ))}
                  <span className="text-xs text-foreground-400">{r.size}</span>
                </div>
                <a
                  href="#guide"
                  className="flex items-center gap-1 whitespace-nowrap rounded-md bg-accent-500 px-3 py-1.5 text-xs font-semibold text-background-50 transition-colors hover:bg-accent-600"
                >
                  <i className="ri-download-2-line"></i>
                  获取安装包
                </a>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}